const HealthProfileTestIds = {
  root: 'profile-hp-section',
  header: 'profile-hp-section-header',
  showBtn: 'profile-hp-section-show',
  hideBtn: 'profile-hp-section-hide',
  weightTrackingHeader: 'profile-hp-section-wt-header',
  weightTrackingGraph: 'profile-hp-section-wt-graph',
  weightLossLabel: 'profile-hp-section-wt-weight-loss-label',
  weightLossValue: 'profile-hp-section-wt-weight-loss-value',
  waistSizeLostLabel: 'profile-hp-section-wt-waist-size-label',
  waistSizeLostValue: 'profile-hp-section-wt-waist-size-value',
  noUpdatesLabel: 'profile-hp-section-no-updates',
};

export default HealthProfileTestIds;
